import { setAccessToken, setCookie } from '@backrs_ui/common-ui';

import { ENVIRONMENT } from '../settings';

type GuestSessionResponse = Readonly<{
  token: string;
}>;

export const mintGuestSession = async (): Promise<string | null> => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASEURL}/guest/session`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      console.error('Failed to mint guest session', response.status);

      return null;
    }

    const data = (await response.json()) as Partial<GuestSessionResponse>;

    if (typeof data?.token !== 'string') {
      console.error('Guest session response missing token');

      return null;
    }

    setAccessToken('backrs_ui_token', data.token);
    setCookie(data.token, ENVIRONMENT);

    return data.token;
  } catch (error) {
    console.error('Failed to mint guest session', error);

    return null;
  }
};
